/**
 * classList name toggled on `<html>`. The leading dot is the class this
 * control has always written — it is not a CSS selector.
 */
export const DARK_MODE_SELECTOR = '.k-dark-mode';
